import React from 'react';

const DownloadIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

export const CadDrawingsPage: React.FC = () => {
  const pdfUrl = '/documents/Keder_CAD_Drawings.pdf';

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Keder_CAD_Drawings.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-white">V-Track CAD Drawings</h1>
          <p className="text-gray-400 mt-1">
            Technical drawings and specifications for V-Track installation
          </p>
        </div>
        <button
          onClick={handleDownload}
          className="btn-primary flex items-center gap-2 whitespace-nowrap"
        >
          <DownloadIcon />
          <span>Download PDF</span>
        </button>
      </div>

      {/* PDF Viewer */}
      <div className="card overflow-hidden">
        <iframe
          src={pdfUrl}
          className="w-full border-0"
          style={{ height: '80vh' }}
          title="V-Track CAD Drawings"
        />
      </div>

      {/* Fallback for browsers that don't support PDF embedding */}
      <div className="text-center text-gray-400 text-sm">
        <p>
          PDF not displaying?{' '}
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-keder-yellow hover:underline"
          >
            Open in new tab
          </a>
        </p>
      </div>
    </div>
  );
};

export default CadDrawingsPage;
